module.exports = __webpack_public_path__ + "img/Priest-undead-f-60.fdc38cbd.gif";